import { DataLayerEvent } from "./events/DataLayerEvent";
import { EventAction } from "./BNGoogleTagManager";

export class UiElementClickEvent extends DataLayerEvent {
  constructor(customAction: EventAction, label?: string) {
    const mappedActipon = mapActionToGa4ClickEventAction(customAction);
    const data: Record<string, string> = {
      ui_element_name: mappedActipon === "unknown" ? customAction : mappedActipon,
    };

    if (label) {
      const mappedLabel = mapLabelToGa4ClickEventLabel(label);
      data.ui_element_value = mappedLabel === "unknown" ? label : mappedLabel;
    }

    super({
      eventName: "ui_element_click",
      data,
    });
  }

  override toGaObject(): object {
    return super.toGaObject();
  }
}

const mapLabelToGa4ClickEventLabel = (label: string): string => {
  switch (label) {
    case "Settings:Konto":
      return "Account";
    case "Alert:Konto":
      return "Account";
    case "Settings:Hjelp":
      return "Help";
    case "Alert:Hjelp":
      return "Help";
    case "Settings:Varsel":
      return "Alert";
    case "Alert:Varsel":
      return "Alert";
    case "Min side":
      return "Home";
    case "Kredittkort":
      return "CreditCard";
    case "Sparing":
      return "Savings";
    case "Lån":
      return "Loan";
    case "Oversikt":
      return "Home";
    case "Bonusopptjening":
      return "BonusEarning";
    case "Vilkår og priser":
      return "TermsAndPrices";
    case "Pdf":
      return "Pdf";
    case "Excel":
      return "Excel";
    case "CUSTOM":
      return "MONTHTODATE";
  }
  return "unknown";
};

const mapActionToGa4ClickEventAction = (action: EventAction): string => {
  switch (action) {
    case EventAction.BottomNavigation:
      return "BottomNavigation";
    case EventAction.Header:
      return "HeaderButton";
    case EventAction.TopMobileNavigation:
      return "TopNavigation";
    case EventAction.ToggleChoosePeriod:
      return "ChoosePeriod";
    case EventAction.ToggleFilterCategory:
      return "FilterCategory";
    case EventAction.ToggleFilter:
      return "Search";
    case EventAction.TransactionClick:
      return "TransactionClick";
    case EventAction.InvoiceAction:
      return "InvoiceAction";
    case EventAction.CreditCardAction:
      return "CreditCardAction";
    case EventAction.ChoosePeriod:
      return "ChoosePeriod";
    case EventAction.ProductBanner:
      return "ProductBanner";
    case EventAction.Download:
      return "Download";
    case EventAction.ChooseDateFrom:
      return "ChooseDateFrom";
    case EventAction.ChooseDateTo:
      return "ChooseDateTo";
    case EventAction.AmountFrom:
      return "AmountFrom";
    case EventAction.AmountTo:
      return "AmountTo";
    case EventAction.TransactionSearchText:
      return "TransactionSearchText";
    case EventAction.Other:
      return "Other";
  }
  return "unknown";
};
